/** The option scale's words (DESIGN §4.1): a tile is a short name over an optional caption, and an ordered scale names its two ends. Pure; the catalog's labels are the only source. */
import type { DecisionCatalogEntry } from "@bsim/contracts";
import { OBJECTIVE_LABELS } from "./labels";

/** The most options one row holds; a longer scale wraps in balanced rows. */
export const SCALE_ONE_ROW = 7;
/** A tile caption longer than this is a sentence, not a value: it is said below the bar instead of on the tile. */
export const SHORT_CAPTION = 8;
/** A tile's name is short: a parenthesised value moves to its caption ("Price 25bp above market (card 50bp)" is the name over "card 50bp"; most labels of `decision-names.ts`, such as "Spend +50% vs budget", carry no parenthesis and stay whole), and a long label stops at its first "and". */
export function tileWords(label: string): { readonly name: string; readonly caption: string | null } {
  const paren = /^(.*?)\s*\(([^)]*)\)$/.exec(label);
  if (paren?.[1] !== undefined && paren[2] !== undefined) return { name: paren[1], caption: paren[2].replace(/^-/, "\u2212") };
  const [head] = label.split(/ and /);
  return { name: head !== undefined && label.length > 18 ? head : label, caption: null };
}

/** The two ends of an ordered scale, from the aims the catalog attaches to a move down and up it; null when the decision names neither. */
export function scaleEnds(entry: Pick<DecisionCatalogEntry, "aims">, sub: string): { readonly low: string; readonly high: string } | null {
  const aim = entry.aims?.[sub];
  if (aim?.down === undefined || aim.up === undefined) return null;
  return { low: OBJECTIVE_LABELS[aim.down], high: OBJECTIVE_LABELS[aim.up] };
}
